/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import './styles.scss'
import { TypescriptComponent } from 'components/typescriptExample'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import Chart from '../chart'
import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'

import { Waypoint } from 'react-waypoint'

const ARTICLE_ID = '24144909'
const ADDITIONAL_SHARES = 361

export function AppComponent(props) {
  const isMobile = window.innerWidth < 600
  const isTablet = window.innerWidth < 1025

  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} additionalShares={ADDITIONAL_SHARES} />
      <ThemeSwitch />

      {/* TODO Replace the following segment with your project cover */}
      <header className='ui vertical fitted segment'>
        <div className='ui container'>
          <h1 className='ui header' style={{ marginBottom: 0 }}>
            156 Schweizer Winter im Vergleich
          </h1>
          <h2 className='ui header' style={{ marginTop: 0 }}>
            <div className='small sub header'>
              Dieser Winter hinterlässt eine Reihe an Wetterrekorden.
              Klimatologe Stephan Bader zieht Bilanz.
            </div>
          </h2>
          <p className='ta author'>
            <strong>Von Patrick Vögeli und Marc Brupbacher</strong>
          </p>
        </div>
      </header>

      {/* TODO And probably remove the following segment and replace it with
       your own content */}
      <div className='ui text container chart' style={{ paddingTop: '2em' }}>
        <h3>2019/2020 war der wärmste Winter seit Messbeginn</h3>
        <p>
          Die Abbildung zeigt die Abweichung von der durchschnittlichen
          Wintertemperatur (Dezember/Januar/Februar) in der Schweiz zum
          Referenzzeitraum 1961 bis 1990.
        </p>
      </div>

      <div className='ui text container'>
        <div className='legend'>
          <img
            src={require(`../chart/img/legende.svg`)}
            alt='legende'
            className='ui fluid image'
          />
        </div>
      </div>

      <div className='ui container spaceMobileBottom'>
        <div className='contentWrapper' style={{ marginTop: '0rem' }}>
          <div className='arrowText'>Rang</div>
          <div className='arrowWrapper'>
            <img src={require('./imgs/icon_arrow.svg')} alt='arrow left icon' />
          </div>
        </div>
        <div className='ui grid charts'>
          <div className='ui ten column mobile row'>
            <Chart />
          </div>
        </div>
      </div>

      <Waypoint
        scrollableAncestor={window}
        onEnter={event => {
          if (event.previousPosition === Waypoint.below) {
            window.dataLayer = window.dataLayer || []
            window.dataLayer.push({
              event: 'Interactions',
              event_action: 'vertical-scroll',
              event_label: '20ContentRead'
            })
          }
        }}
      />

      <div className='ui vertical segment'>
        <div className='ui text container' style={{ marginBottom: '2em' }}>
          <h4>War der Winter 2019/2020 ein Jahrhundertwinter?</h4>
          <p>
            Momentan zeichnet sich schweizweit der mildeste Winter seit
            Messbeginn 1864 ab. Lokal brachte der Winter 1&nbsp;°C mehr als die
            bisher mildesten Rekord-Winter von 2006/07 und 2015/16. In diesem
            Sinne ist die Bezeichnung Jahrhundertwinter durchaus gerechtfertigt.
            Es ist die seit Dezember fast durchwegs überdurchschnittlich hohe
            Tagestemperatur, welche in der Summe über drei Monate zum extremen
            Saisonmittel führt.
          </p>
        </div>

        <div className='ui text container chart'>
          <h3>Dieser Winter war 3 Grad zu warm</h3>
          <p>
            Monatsmittel der Temperaturen in Grad Celsius in der Schweiz seit
            1864
          </p>
          <div className='linechartWrapper'>
            <div className='linechartContainer'>
              <div className='linechartLegendFive' />
              <div className='linechartText'>2020</div>
            </div>
            <div className='linechartContainer'>
              <div className='linechartLegendFour' />
              <div className='linechartText'>2019</div>
            </div>
            <div className='linechartContainer'>
              <div className='linechartLegendTwo' />
              <div className='linechartText'>
                Mittel Referenz&shy;zeitraum{' '}
                <span style={{ whiteSpace: 'nowrap' }}>1961–1990</span>
              </div>
            </div>
          </div>
        </div>
        <div className='ui container iframe'>
          <AutofitIFrame
            title='Dieser Winter war 3 Grad zu warm'
            aria-label='Interactive line chart'
            src='//datawrapper.dwcdn.net/6hF0r/8/'
            height={isTablet ? (isMobile ? '440' : '540') : '640'}
            width='600'
          />
        </div>

        <div className='ui text container' style={{ marginBottom: '2em' }}>
          <h4>
            War das ein Winter, wie wir ihn in 40 Jahren jedes Jahr erleben
            werden?
          </h4>
          <p>
            Die bisherigen Analysen zum Wettermuster des zukünftigen Winters in
            der Schweiz brachten sehr unterschiedliche Resultate. Daraus lässt
            sich vorderhand kein typischer zukünftiger Winter ableiten. Alle
            Modellrechnungen zeigen hingegen für die kommenden Jahrzehnte
            übereinstimmend eine fortschreitende Wintererwärmung. Seit der
            vorindustriellen Periode 1871−1900 ist der Schweizer Winter knapp
            2&nbsp;°C milder geworden. Bis Mitte Jahrhundert ist ohne
            Klimaschutz ein weiterer Anstieg der Wintertemperatur um 2 bis
            3,5&nbsp;°C möglich.
          </p>
        </div>

        <Waypoint
          scrollableAncestor={window}
          onEnter={event => {
            if (event.previousPosition === Waypoint.below) {
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                event: 'Interactions',
                event_action: 'vertical-scroll',
                event_label: '50ContentRead'
              })
            }
          }}
        />

        <div className='ui text container' style={{ marginBottom: '2em' }}>
          <h4>
            Wie sah es diesen Winter mit Niederschlag und Schnee aus? Lag die
            Menge in der Norm?
          </h4>
          <p>
            In weiten Teilen der Schweiz fielen Wintersummen im Bereich der Norm
            1981–2010 oder leicht darüber. Unterdurchschnittlich blieben die
            Niederschläge in der Nordwestschweiz, am zentralen Alpennordhang und
            im Engadin. Auffallend war der landesweit niederschlagsarme Januar.
            Meist grün war der bisherige Winter vor allem bis in eine Höhenlage
            von rund 1000 m. Darüber sank die Schneehöhe periodisch unter den
            Durchschnitt, blieb aber meist im normalen Schwankungsbereich. In
            hohen Lagen verlief der Schneedeckenaufbau regional entsprechend dem
            langjährigen Durchschnitt.
          </p>
        </div>

        <div className='ui text container chart'>
          <h3>Der Winter 2019/2020 war normal nass</h3>
          <p>
            Monatsmittel der Niederschlagsmenge in Milimeter in der Schweiz seit
            1900
          </p>
          <div className='linechartWrapper'>
            <div className='linechartContainer'>
              <div className='linechartLegendSeven' />
              <div className='linechartText'>2020</div>
            </div>
            <div className='linechartContainer'>
              <div className='linechartLegendThree' />
              <div className='linechartText'>2019</div>
            </div>
            <div className='linechartContainer'>
              <div className='linechartLegendTwo' />
              <div className='linechartText'>
                Mittel Referenz&shy;zeitraum{' '}
                <span style={{ whiteSpace: 'nowrap' }}>1961–1990</span>
              </div>
            </div>
          </div>
        </div>

        <div className='ui container iframe'>
          <AutofitIFrame
            title='Der Winter 2019/2020 war normal nass'
            aria-label='Interactive line chart'
            src='//datawrapper.dwcdn.net/nXh4q/3/'
            height={isTablet ? (isMobile ? '440' : '540') : '640'}
            width='600'
          />
        </div>

        <div className='ui text container' style={{ marginBottom: '2em' }}>
          <h4>
            Wir erlebten mindestens drei Winterstürme. Wie passt das in den
            Wandel?
          </h4>
          <p>
            In den letzten Jahren wurden in der Schweiz eher wenig Tage mit
            hohen Windspitzen registriert. Ab Mitte der 1980er-Jahre bis etwa
            2005 war es häufiger stürmisch. Es ist davon auszugehen, dass dies
            vorwiegend natürliche Schwankungen des Klimasystems sind. Das
            scheint auch so zu bleiben. In den Klimaszenarien gibt es keine
            eindeutigen Hinweise, dass sich die Häufigkeit starker Windspitzen
            in Zukunft in eine bestimmte Richtung bewegt. Allerdings ist noch
            nicht klar, wie vertrauenswürdig die heutigen Klimamodelle mögliche
            Änderungen von Windspitzen darstellen können.
          </p>
        </div>

        <div className='ui text container chart'>
          <h3>
            Im Winter 2019/2020 gab es überdurch&shy;schnittlich viel Sonne
          </h3>
          <p>Monatsmittel der Sonnenstunden in der Schweiz seit 1961</p>
          <div className='linechartWrapper'>
            <div className='linechartContainer'>
              <div className='linechartLegendSix' />
              <div className='linechartText'>2020</div>
            </div>
            <div className='linechartContainer'>
              <div className='linechartLegendOne' />
              <div className='linechartText'>2019</div>
            </div>
            <div className='linechartContainer'>
              <div className='linechartLegendTwo' />
              <div className='linechartText'>
                Mittel Referenz&shy;zeitraum{' '}
                <span style={{ whiteSpace: 'nowrap' }}>1961–1990</span>
              </div>
            </div>
          </div>
        </div>

        <div className='ui container iframe'>
          <AutofitIFrame
            title='Im Winter 2019/2020 gab es überdurchschnittlich viel Sonne'
            aria-label='Interactive line chart'
            src='//datawrapper.dwcdn.net/Rpu9w/6/'
            height={isTablet ? (isMobile ? '440' : '540') : '640'}
            width='600'
          />
        </div>

        <Waypoint
          scrollableAncestor={window}
          onEnter={event => {
            if (event.previousPosition === Waypoint.below) {
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                event: 'Interactions',
                event_action: 'vertical-scroll',
                event_label: '75ContentRead'
              })
            }
          }}
        />

        <div className='ui text container' style={{ marginBottom: '2em' }}>
          <h4>
            Schauen wir uns die drei Wintermonate Dezember, Januar und Februar,
            jeden für sich, etwas genauer an.
          </h4>
          <p>
            <b>Dezember 2019:</b>
            <br />
            Mit dem landesweit drittwärmsten Dezember seit Messbeginn erlebte
            die Schweiz einen extrem milden Winterbeginn. Einzelne Föhntäler der
            Alpennordseite registrierten gar den mildesten oder zweitmildesten
            Dezember seit Messbeginn. Die Dezembertemperatur lag nördlich der
            Alpen und in den Alpen verbreitet 2 bis 3&nbsp;°C über der Norm
            1981‒2010. In den Föhntälern der Alpennordseite stieg der Dezember 3
            bis 4&nbsp;°C über die Norm. Auf der Alpensüdseite und im Engadin
            bewegten sich die Dezemberwerte meist 1,5 bis 2&nbsp;°C, lokal bis
            2,4&nbsp;°C über der Norm 1981‒2010. Im landesweiten Mittel lag der
            Dezember 2,5&nbsp;°C über der Norm.
          </p>
          <p>
            <b>Januar 2020:</b>
            <br />
            Die Schweiz registrierte in Höhenlagen über 1000 m den drittwärmsten
            Januar seit Messbeginn 1864. Lokal bewegte sich der Januar im
            Rekordbereich. Auf der Alpennordseite war es regional der sonnigste
            Januar seit Messbeginn vor über 100 Jahren. In der ganzen Schweiz
            zeigte sich der Januar sehr niederschlagsarm. Die Januartemperatur
            lag in tieferen Lagen der Alpennordseite verbreitet 2 bis 3&nbsp;°C,
            regional 1,5 bis 2&nbsp;°C über der Norm 1981‒2010. In Berglagen
            stieg der Januar 3 bis 3,6&nbsp;°C über die Norm. Im Engadin und im
            Oberwallis bewegten sich die Werte 0,4 bis 1,7&nbsp;°C über der
            Norm. Die Alpensüdseite registrierte verbreitet Januarwerte von 1
            bis 2&nbsp;°C über der Norm 1981‒2010. Im landesweiten Mittel lag
            der Januar 2,4&nbsp;°C über der Norm.
          </p>
          <p>
            <b>Februar 2020:</b>
            <br />
            Nach den momentanen Berechnungen bis zum Monatsende (Stand
            20.2.2020) zeichnet sich auf der Alpensüdseite und in der
            Westschweiz ein neuer Februarrekord ab. In den Niederungen des
            Tessins liegt die erwartete Februartemperatur von 8 bis 9&nbsp;°C
            rund 1&nbsp;°C über dem bisherigen Rekord. In der Westschweiz dürfte
            der Februar mit 6,5 bis 7,5&nbsp;°C etwa 0,5 bis knapp 1&nbsp;°C
            über den bisherigen Höchstwerten zu liegen kommen. Im landesweiten
            Mittel wird sich der Februar 2020 voraussichtlich in die fünf
            wärmsten Februarmonate seit Messbeginn 1864 einreihen. Mit der Wärme
            kam auf der Alpensüdseite auch die grosse Trockenheit. Die
            Niederschlagsmengen erreichten verbreitet weniger als 20% der Norm
            1981‒2010. Auf der Alpennordseite und in den Alpen fiel hingegen
            reichlich Niederschlag, oft als Regen bis in grössere Höhen. Viele
            Gebiete erhielten 150 bis 200% der Norm.
          </p>
        </div>

        {/* <div className='ui text container'>
          <h4>Frage</h4>
          <p>
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
            nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam
            erat, sed diam voluptua. At vero eos et accusam et justo duo dolores
            et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est
            Lorem ipsum dolor sit amet.
          </p>
          <div className='snippet'>
            <a href="https://interaktiv.<%= customer::customer('url_hostname_only_really') %>.ch/2019/klimazukunft-2060/?nosome">
              <img
                src='https://interaktiv.tagesanzeiger.ch/2019/klimazukunft-2060/mini-teaser-klimazukunft-2060-neutral.jpg'
                width='100%'
              />
            </a>
          </div>
        </div> */}
      </div>

      {/* TODO Add your credits in this component */}
      <Footer
        articleId={ARTICLE_ID}
        additionalShares={ADDITIONAL_SHARES}
        questions={[
          'Wie informativ war der Beitrag?',
          'Wie gefallen Ihnen die Grafiken?'
        ]}
        credits={[
          [
            'Konzept, Programmierung und Gestaltung',
            'Patrick Vögeli und Marc Brupbacher'
          ],
          ['Experten-Interview', 'Stephan Bader, Klimatologe MeteoSchweiz'],
          ['Daten', 'MeteoSchweiz']
        ]}
      />
    </div>
  )
}
